import React, { memo } from 'react';

import { IPointsConfig } from '../../../types/HostMetadata';
import {
  IUserProfileDetails,
  UserAccountType,
  UserProfileView,
  UserProfileViewType,
} from '../types';
import ProfileCompletionResponses from './ProfileCompletionResponses';
import UserProfileCard from './UserProfileCard';

interface Props {
  userId: string;
  profileDetails: IUserProfileDetails;
  setProfileDetails: (details: IUserProfileDetails) => void;
  pointsConfig: IPointsConfig;
  isTagMango: boolean;
  mangoesTitle: string;
  accountType: UserAccountType;
  viewerType: UserAccountType;
  isViewerSelf?: boolean;
  view: UserProfileViewType;
}

const UserProfileAbout: React.FC<Props> = ({
  userId,
  profileDetails,
  setProfileDetails,
  pointsConfig,
  isTagMango,
  mangoesTitle,
  accountType,
  viewerType,
  isViewerSelf,
  view,
}) => {
  return (
    <div className="user-profile__tab user-profile__tab--about">
      <UserProfileCard
        profileDetails={profileDetails}
        setProfileDetails={setProfileDetails}
        pointsConfig={pointsConfig}
        isTagMango={isTagMango}
        mangoesTitle={mangoesTitle}
        userId={userId}
        showAboutContent
        view={view}
      />

      {view === UserProfileView.TQ_CONNECT_PROFILE &&
        accountType === 'subscriber' && (
          <>
            <ProfileCompletionResponses
              userProfileId={userId}
              userProfilePicUrl={profileDetails?.userProfile?.profilePicUrl}
              userProfileType={profileDetails?.userProfile?.onboarding}
              viewerType={viewerType}
              isViewerSelf={isViewerSelf}
            />
          </>
        )}
    </div>
  );
};

export default memo(UserProfileAbout);
